// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"4d5b79bd57e6d130ab22","133":"2789829762226c6cfffd","134":"f6c6b8ba053e6edee603","181":"f5a3d7616a1140ede459"}[chunkId] + ".chunk.js";
};